import * as Yup from 'yup';
import { isSequentialOrRepeatable } from '../utils/index';
import EN from '../../EN.json';
import FR from '../../FR.json';

const { 
  USERS:{
    USER_AUTHENTICATION:{
      UPDATE_PASSWORD_SCHEMA:{
        BOTH_PASS_SAME,
        CONFIRM_PASS
      },
      REGISTRATION_SCHEMA_MESSAGES:{
        PASSWORD_MATCHES,
        PASSWORD_REPEAT,
        PASSWORD_REQUIRED
      }
    }
  }
} =  localStorage.getItem('locale') ? (localStorage.getItem('locale') === 'EN' ? EN : FR) : EN;

const updatePasswordSchema = Yup.object().shape({
  newPassword: Yup.string()
    .required(PASSWORD_REQUIRED)
    .matches(
      /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/,
      PASSWORD_MATCHES
    )
    .test(
      'password',
      PASSWORD_REPEAT,
      isSequentialOrRepeatable
    ),
  confirmPassword: Yup.string()
    .required(CONFIRM_PASS)
    .when('newPassword', {
      is: val => !!(val && val.length > 0),
      then: Yup.string().oneOf(
        [Yup.ref('newPassword')],
        BOTH_PASS_SAME
      )
    })
});

export default updatePasswordSchema;